import { initializeApp } from 'firebase/app'
import {
  getDatabase, ref, collection, push, update, onValue, child, set,
} from 'firebase/database'
import { serverTimestamp } from '@firebase/database'

const firebaseConfig = {
  apiKey: 'AIzaSyDOQE4ExEpWo0SAMlzeDsLVFgD8D0Qca9o',
  authDomain: 'notificaodkplayer.firebaseapp.com',
  databaseURL: 'https://notificaodkplayer-default-rtdb.europe-west1.firebasedatabase.app',
  projectId: 'notificaodkplayer',
  storageBucket: 'notificaodkplayer.appspot.com',
  messagingSenderId: '504422882073',
  appId: '1:504422882073:web:0fd9736ff1ba1ac91c4388',
  measurementId: 'G-W96RPPRMT5',
}

const app = initializeApp(firebaseConfig)
const db = getDatabase()

export {
  app,
  db,
  onValue,
  ref,
  update,
  push,
  collection,
  serverTimestamp,
  child,
  set,
}
